export default __webpack_public_path__ + "static/features-flexible-d7ecbd3029b7544416808c2be40d8744.jpg";